module.exports = __webpack_public_path__ + "assets/cdnjs.2d526704.svg";